module.exports = __webpack_public_path__ + "img/35.74174b96.jpg";